import { IStorageRedux } from '../../types/storage';

export const initialState: IStorageRedux = {
    yourNumber: {},
};
